import React from 'react';
import { Link } from 'react-router-dom';
import { routes } from '../../../routes';
import Typography from '../../Typography';
import styles from './EmptyCart.module.sass';

const EmptyCart = () =>
  <>
    <Typography tag="h3">Empty</Typography>
    <Typography>
      <Link to={routes.studentIdEntry()} className={styles.link}>Purchase Pictures</Link> to add items to your cart.
    </Typography>
  </>

export default EmptyCart;
